// noinspection JSUnusedGlobalSymbols

/*
 *                     NOTICE
 *            COPYRIGHT 2022 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { bootstrapAndAuth } from "abreact/incubator/ui/app/bootstrap/ReactBootstrapAndAuthStrategy";
import { StatefulServerAuthenticationStrategy } from "abreact/service/authentication/StatefulServerAuthenticationStrategy";
import { ModuleLoaderUtils } from "abweb/utils/ModuleLoaderUtils";
import { abAppLoaderPreloadSpecs } from "cafe/app/AbAppLoaderPreloadSpecs"; // do NOT import cafe/app/AbAppLoader!

// Restrict keys of T to those that are of AllowedT type.
// copy/pasted from BootstrapApp to avoid pulling BootstrapApp into the AbSDK interface.

/**
 * Start an AbSDK application, given a function that imports the application's ApplicationConfig and the export name
 * of configuration class.  The ApplicationConfig is constructed at the appropriate time to configure and display
 * the application.
 * @param importModuleFn Function that imports ApplicationConfig, for example `() => import("./AppConfig")`
 * @param appConfigExportName The export name of the application config.
 * @param appPreloadSpecs Import specs of application-specific modules that will be loaded in the background
 * while the login dialog is being displayed.  Defaults to empty array.
 */
export function bootstrapApplication(importModuleFn, appConfigExportName, appPreloadSpecs = [], abReactServicesConfig) {
  // Define continuation fn that will be invoked after authorization has successfully completed.

  const startApp = generateBootstrapAppLoaderFn(importModuleFn, appConfigExportName);
  return bootstrapApp({
    startApp,
    appPreloadSpecs,
    abReactServicesConfig
  });
}
export function generateBootstrapAppLoaderFn(importModuleFn, appConfigExportName) {
  return async function startApp(alProps) {
    // Lazily import AbAppLoader module ONLY AFTER login succeeds as imports every library (also see abAppPreloadSpecs above)
    const startAppWithModuleFn = await ModuleLoaderUtils.loadExport(() => import(/* webpackChunkName: "cafe/app/AbAppLoader" */"cafe/app/AbAppLoader"), "startAppWithModule");
    return startAppWithModuleFn(importModuleFn, appConfigExportName, alProps);
  };
}
export function bootstrapApp(options) {
  const {
    startApp,
    appPreloadSpecs = [],
    abReactServicesConfig,
    abWebServicesConfig,
    customErrorHandlers,
    preAuthHook,
    portalLoginView
  } = options;
  // Auto-pre-loaded in background while login dialog is being displayed
  const preloadSpecs = [...abAppLoaderPreloadSpecs, ...appPreloadSpecs];
  return bootstrapAndAuth({
    startApp,
    requiredLoginRole: "ROLE_AUTHENTICATED_USER",
    preloadSpecs,
    abWebServicesConfig: {
      ...abWebServicesConfig,
      authenticationStrategy: new StatefulServerAuthenticationStrategy()
    },
    abReactServicesConfig,
    customErrorHandlers,
    preAuthHook,
    portalLoginView
  });
}
//# sourceMappingURL=AbApplicationBootstrap.js.map
